/* ⚛ REACT */
import{ useState, useEffect } from "react";

/* 📦 LIBS */
import { useTour } from "@reactour/tour";

/* 🎨 STYLES */
import { Container, SwitchContainer, Input, Slider, Button, TextString } from "./styles";

/**
 * Componente para controle responsável pelo estado 
 * @param {boolean} State estado inicial da aplicação
 * @param {Function} onChange muda o estado da aplicação
 * @param {boolean} disabled indica se o estado é fixo (default: false)
 * @param {string} caseOnString letra para indicar o estado ligado
 * @param {string} caseOffString letra para indicar o estado desligado
 * @param {string} colorOn cor para o estado ligado do texto
 * @param {string} colorOnSlider cor para o estado ligado do switch
 * @param {string} colorOff cor para o estado desligado do texto
 * @param {string} colorOffSlider cor para o estado desligado do switch
 * @returns {ReactComponentElement} 
 */
const Switch = ({id, className, State, onChange, disabled, caseOnString, caseOffString, colorOnSlider, colorOffSlider, colorOn, colorOff}) =>{
    const { isOpen } = useTour();
    const [isChecked, setIsChecked] = useState(State);

    useEffect(()=>{
        setIsChecked(State);
    }, [State])

    const handleToggle = () => {
        onChange(!isChecked);
        setIsChecked(!isChecked);
    };

    return (
        <Container id={id} className={className}>
            <TextString color={isChecked ? colorOff : colorOn}>{caseOffString}</TextString>
            <SwitchContainer>
                <Input id="input-switch" type="checkbox" disabled={disabled} checked={isChecked}  onChange={(e) => (!e.isTrusted || !isOpen) && handleToggle()} />
                <Slider checked={isChecked} $colorOn={colorOnSlider} $colorOff={colorOffSlider}/>
                <Button checked={isChecked} $colorOn={colorOnSlider} $colorOff={colorOffSlider}>
                    {isChecked ? caseOnString[0] : caseOffString[0]}
                </Button>
            </SwitchContainer>
            <TextString color={isChecked ? colorOn : colorOff}>{caseOnString}</TextString>
        </Container>
    );
}

export default Switch;

